export const AUTH_TOKEN_KEY = "persist:eamd-auth";
